import {Observable} from 'rxjs/Rx';
import {Injectable} from '@angular/core';
import {EndpointConfig} from '../Impl/EndpointConfig';
import {HttpResponse} from '@angular/common/http';
/**
 * @abstract
 */
export abstract class Callable {
public config: EndpointConfig;
/**
 * @abstract
 * @param {?} absoluteUrl
 * @param {?} method
 * @param {?=} requestData
 * @return {?}
 */
call(absoluteUrl: string, method: string, requestData?: any) {}
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function Callable_tsickle_Closure_declarations() {
/** @type {?} */
Callable.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Callable.ctorParameters;
/** @type {?} */
Callable.prototype.config;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
